import userApi from './user'
import predictApi from './predict'
import lotteryApi from './lottery'
import systemApi from './system'
import contentApi from './content'
import paymentApi from './payment'
import notificationApi from './notification'
import manualPlanApi from './manualPlan'

export default {
    ...userApi,
    ...predictApi,
    ...lotteryApi,
    ...systemApi,
    ...contentApi,
    ...paymentApi,
    ...notificationApi,
    ...manualPlanApi
}
